import { hasRecentSubscriptionData } from '@dolfin/business/domains/subscriptions'
import type { Database } from '@dolfin/business/db_types'
import { DolfinRpcFactory } from '@dolfin/business/rpc/factory'
import { QueryKeys } from '@dolfin/hooks/queryKeys'
import { useSupabaseClient } from '@dolfin/hooks/supabase'
import { useMemo } from 'react'
import { useQuery } from 'react-query'

export const HAS_RECENT_SUBSCRIPTION_DATA_QUERY_KEY =
  'HAS_RECENT_SUBSCRIPTION_DATA'

export const useHasRecentSubscriptionData = (params: {
  organizationId?: number
  profileId?: string
  enabled?: boolean
}) => {
  const supabase = useSupabaseClient<Database>()
  const rpcClient = useMemo(
    () => DolfinRpcFactory.create(DolfinRpcFactory.DolfinRpcTypes.SUPABASE, supabase),
    [supabase]
  )

  return useQuery(
    [
      QueryKeys.profiles.get,
      HAS_RECENT_SUBSCRIPTION_DATA_QUERY_KEY,
      params.organizationId,
      params.profileId
    ],
    () =>
      hasRecentSubscriptionData(rpcClient, {
        organizationId: params.organizationId!,
        profileId: params.profileId!
      }),
    {
      enabled:
        (params.enabled ?? true) &&
        typeof params.organizationId === 'number' &&
        !!params.profileId
    }
  )
}
